/**
 * Returns a formatted version of the test result
 * @param testResult - The test result string to be formatted.
 * @returns A formatted version of the test result
 */
export const getFormattedTestResult = (testResult: string): string => {
  let testResultCopy = testResult

  /* Replacing markdown links to html links in test result string */
  testResultCopy = testResultCopy.replaceAll(/\[[^\]\r\n]*\]\([^()\r\n]*\)/g, match => {
    const closingBracketIndex = match.indexOf('](')

    if (closingBracketIndex === -1 || !match.startsWith('[') || !match.endsWith(')')) {
      return match
    }

    const linkText = match.slice(1, closingBracketIndex)
    const linkTarget = match.slice(closingBracketIndex + 2, -1)

    return `<a href="${linkTarget}">${linkText}</a>`
  })

  return testResultCopy
}
